export default __webpack_public_path__ + "static/media/git.6032eec5.png";